<div id="footer-control-bar-wrapper" class="k-w-full">
  <div id="footer-control-bar-section" class="card k-rounded-none !k-border-r-0 !k-border-b-0">
    <div id="footer-control-bar" class="justify-content-end k-d-flex">
      <ng-container [ngTemplateOutlet]="controlBarTemplate"></ng-container>
    </div>
  </div>
</div>
